import React from 'react';
import { Listbox } from '@headlessui/react';
import { menuItemsStyle } from '@teetsh/app/src/components/Menu/MenuItems';
import { menuItemStyle } from '@teetsh/app/src/components/Menu/MenuItem';
import tw from 'twin.macro';
import { CheckIcon as Check } from '@heroicons/react/20/solid';
import styled from '@emotion/styled';
import { IconSize } from '@teetsh/app/src/components/Icons/icon';
import { Option } from './types';
import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';

interface Props<T> {
  noDisplayCurrent?: boolean;
  value?: T;
  options: Option<T>[];
  intent?: Intent;
  withoutCheck?: boolean;
}

const StyledIcon = styled.div(
  (p: {
    invisible?: boolean;
    iconSize?: IconSize;
    position?: 'left' | 'right';
  }) => [tw`shrink-0 mr-2`, p.invisible && tw`invisible`],
);

export function ListOptions<T>(props: Props<T>) {
  const { value, noDisplayCurrent, options, intent, withoutCheck } = props;

  return (
    <Listbox.Options
      static
      css={[menuItemsStyle]}
      tw="z-30 mt-1 w-full max-h-60 py-1 text-base overflow-auto focus:outline-none sm:text-sm"
    >
      {options
        .filter(opt => (noDisplayCurrent ? opt.value !== value : true))
        .map(option => (
          //@ts-ignore
          <Listbox.Option
            disabled={option.disabled}
            key={option.value as any}
            value={option.value}
          >
            {({ selected, active }) => (
              <div
                role="presentation"
                css={[
                  menuItemStyle({ active }),
                  tw`cursor-pointer select-none relative py-2 pl-3 pr-3 focus:outline-none flex`,
                  option.disabled && tw`text-neutral-quiet cursor-not-allowed`,
                  intent === 'primary' &&
                    !option.disabled &&
                    tw`hover:bg-brand-moderate`,
                ]}
                onClick={() => {
                  if (!option.disabled && option.onClick) {
                    option.onClick();
                  }
                }}
              >
                {option.icon && (
                  <StyledIcon as={option.icon as any} tw="h-5 w-5" />
                )}
                <span css={[tw`font-semibold block`]}>{option.label}</span>
                {option.sublabel && (
                  <span
                    css={[
                      tw`font-normal text-xs block pr-8 text-muted`,
                      selected && tw`font-semibold`,
                    ]}
                  >
                    {option.sublabel}
                  </span>
                )}

                {selected && !withoutCheck ? (
                  <span tw="ml-2 flex items-center">
                    <Check tw="h-5 w-5" />
                  </span>
                ) : null}
              </div>
            )}
          </Listbox.Option>
        ))}
    </Listbox.Options>
  );
}
